import type { AppState } from '@app/external/common/types';

// old version
export const getViewedUserSiteMemberId = (state: AppState) => state.viewedUser;
